import { ReactNode } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import L from 'leaflet';

import { DivMarker } from './Markers/DivMarker';

export const reactComponentToLeafletIcon = (icon: ReactNode, backgroundColor?: string) => {
  return L.divIcon({
    html: renderToStaticMarkup(DivMarker(icon, backgroundColor)),
    iconSize: [30, 30],
  });
};
